/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Items_Table_Lastmodified1Inputs */

const id_items_table_lastmodified1 = /** @type {(inputs: Items_Table_Lastmodified1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terakhir Dimodifikasi`)
};

const ms_items_table_lastmodified1 = /** @type {(inputs: Items_Table_Lastmodified1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diubah Suai Terakhir`)
};

const da_items_table_lastmodified1 = /** @type {(inputs: Items_Table_Lastmodified1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sidst Ændret`)
};

const de_items_table_lastmodified1 = /** @type {(inputs: Items_Table_Lastmodified1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zuletzt geändert`)
};

const en_us2_items_table_lastmodified1 = /** @type {(inputs: Items_Table_Lastmodified1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last Modified`)
};

const es_es2_items_table_lastmodified1 = /** @type {(inputs: Items_Table_Lastmodified1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Última modificación`)
};

const es_mx2_items_table_lastmodified1 = /** @type {(inputs: Items_Table_Lastmodified1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Última modificación`)
};

const fil_items_table_lastmodified1 = /** @type {(inputs: Items_Table_Lastmodified1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huling Binago`)
};

const fr_items_table_lastmodified1 = /** @type {(inputs: Items_Table_Lastmodified1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dernière modification`)
};

const it_items_table_lastmodified1 = /** @type {(inputs: Items_Table_Lastmodified1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultima modifica`)
};

const hu_items_table_lastmodified1 = /** @type {(inputs: Items_Table_Lastmodified1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utolsó módosítás`)
};

const nl_items_table_lastmodified1 = /** @type {(inputs: Items_Table_Lastmodified1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laatst gewijzigd`)
};

const no_items_table_lastmodified1 = /** @type {(inputs: Items_Table_Lastmodified1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sist endret`)
};

const pl_items_table_lastmodified1 = /** @type {(inputs: Items_Table_Lastmodified1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ostatnia modyfikacja`)
};

const pt_br2_items_table_lastmodified1 = /** @type {(inputs: Items_Table_Lastmodified1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Última modificação`)
};

const pt_items_table_lastmodified1 = /** @type {(inputs: Items_Table_Lastmodified1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Última modificação`)
};

const ro_items_table_lastmodified1 = /** @type {(inputs: Items_Table_Lastmodified1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultima modificare`)
};

const fi_items_table_lastmodified1 = /** @type {(inputs: Items_Table_Lastmodified1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viimeksi muokattu`)
};

const sv_items_table_lastmodified1 = /** @type {(inputs: Items_Table_Lastmodified1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senast ändrad`)
};

const vi_items_table_lastmodified1 = /** @type {(inputs: Items_Table_Lastmodified1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sửa đổi lần cuối`)
};

const tr_items_table_lastmodified1 = /** @type {(inputs: Items_Table_Lastmodified1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Son Değiştirilme`)
};

const cs_items_table_lastmodified1 = /** @type {(inputs: Items_Table_Lastmodified1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poslední změna`)
};

const bg_items_table_lastmodified1 = /** @type {(inputs: Items_Table_Lastmodified1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Последна промяна`)
};

const ru_items_table_lastmodified1 = /** @type {(inputs: Items_Table_Lastmodified1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Последнее изменение`)
};

const uk_items_table_lastmodified1 = /** @type {(inputs: Items_Table_Lastmodified1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Остання зміна`)
};

const ar_items_table_lastmodified1 = /** @type {(inputs: Items_Table_Lastmodified1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آخر تعديل`)
};

const hi_items_table_lastmodified1 = /** @type {(inputs: Items_Table_Lastmodified1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अंतिम संशोधन`)
};

const th_items_table_lastmodified1 = /** @type {(inputs: Items_Table_Lastmodified1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แก้ไขล่าสุด`)
};

const ja_items_table_lastmodified1 = /** @type {(inputs: Items_Table_Lastmodified1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最終更新`)
};

const zh_cn2_items_table_lastmodified1 = /** @type {(inputs: Items_Table_Lastmodified1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最后修改`)
};

const zh_hant1_items_table_lastmodified1 = /** @type {(inputs: Items_Table_Lastmodified1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最後修改`)
};

const ko_items_table_lastmodified1 = /** @type {(inputs: Items_Table_Lastmodified1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`마지막 수정`)
};

/**
* | output |
* | --- |
* | "Last Modified" |
*
* @param {Items_Table_Lastmodified1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const items_table_lastmodified1 = /** @type {((inputs?: Items_Table_Lastmodified1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Items_Table_Lastmodified1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_items_table_lastmodified1(inputs)
	if (locale === "ms") return ms_items_table_lastmodified1(inputs)
	if (locale === "da") return da_items_table_lastmodified1(inputs)
	if (locale === "de") return de_items_table_lastmodified1(inputs)
	if (locale === "en-US") return en_us2_items_table_lastmodified1(inputs)
	if (locale === "es-ES") return es_es2_items_table_lastmodified1(inputs)
	if (locale === "es-MX") return es_mx2_items_table_lastmodified1(inputs)
	if (locale === "fil") return fil_items_table_lastmodified1(inputs)
	if (locale === "fr") return fr_items_table_lastmodified1(inputs)
	if (locale === "it") return it_items_table_lastmodified1(inputs)
	if (locale === "hu") return hu_items_table_lastmodified1(inputs)
	if (locale === "nl") return nl_items_table_lastmodified1(inputs)
	if (locale === "no") return no_items_table_lastmodified1(inputs)
	if (locale === "pl") return pl_items_table_lastmodified1(inputs)
	if (locale === "pt-BR") return pt_br2_items_table_lastmodified1(inputs)
	if (locale === "pt") return pt_items_table_lastmodified1(inputs)
	if (locale === "ro") return ro_items_table_lastmodified1(inputs)
	if (locale === "fi") return fi_items_table_lastmodified1(inputs)
	if (locale === "sv") return sv_items_table_lastmodified1(inputs)
	if (locale === "vi") return vi_items_table_lastmodified1(inputs)
	if (locale === "tr") return tr_items_table_lastmodified1(inputs)
	if (locale === "cs") return cs_items_table_lastmodified1(inputs)
	if (locale === "bg") return bg_items_table_lastmodified1(inputs)
	if (locale === "ru") return ru_items_table_lastmodified1(inputs)
	if (locale === "uk") return uk_items_table_lastmodified1(inputs)
	if (locale === "ar") return ar_items_table_lastmodified1(inputs)
	if (locale === "hi") return hi_items_table_lastmodified1(inputs)
	if (locale === "th") return th_items_table_lastmodified1(inputs)
	if (locale === "ja") return ja_items_table_lastmodified1(inputs)
	if (locale === "zh-CN") return zh_cn2_items_table_lastmodified1(inputs)
	if (locale === "zh-Hant") return zh_hant1_items_table_lastmodified1(inputs)
	return ko_items_table_lastmodified1(inputs)
});
export { items_table_lastmodified1 as "items.table.lastModified" }